// extracted by mini-css-extract-plugin
export var fadeInOut = "_k-3";
export var icon = "_k-4";
export var savedIndicator = "_k-2";
export var savingIndicator = "_k-0";
export var spin = "_k-1";